import { IAttribute } from '../components/DTStudio/interfaces'

const hasValue = (value: unknown): boolean =>
    Array.isArray(value)
        ? value.length > 0
        : value !== null && value !== undefined && value !== ''

/**
 * Names of the fields to tell the user were cleared when the Program or Type
 * changed. Only a value the user could see before the change counts as
 * cleared: a field that was already empty (cleared by an earlier switch) has
 * lost nothing, so it is left out.
 */
export const getClearedAttributeNames = (
    attributes: Pick<IAttribute, 'id' | 'name'>[],
    clearedIds: string[],
    previousAttributes: Pick<IAttribute, 'id' | 'value'>[],
): string[] =>
    attributes
        .filter(
            (attribute) =>
                clearedIds.includes(attribute.id) &&
                hasValue(
                    previousAttributes.find((p) => p.id === attribute.id)
                        ?.value,
                ),
        )
        .map((attribute) => attribute.name)
